import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Note } from '../classes/models';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  getNotes(query = {}) {
    return this.http.get<Note[]>(`/api/v2/note/many`, { params: query });
  }

  getNote(query = {}) {
    return this.http.get<Note>(`/api/v2/note/one`, { params: query });
  }

  getNoteCount(query = {}) {
    return this.http.get<number>(`/api/v2/note/count`, { params: query });
  }

  saveNote(Note: Note, query = {}) {
    return this.http.post<Note>(`/api/v2/note`, Note, { params: query });
  }
}
